
export enum EPortalSourceTypes {
    PORTAL = "PORTAL"
}
